import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import './style.css';
import app from 'new-ui/app';
import { ROUTE_PATH, ROUTE_NAME } from 'utils/constants/router';
import { useTranslation } from 'utils/modifiedTranslation';
import WidgetBtn from '../Button';
import AssistanceButton from '../AssistanceButton';
import { FEED_GA } from '../constants';

const ProgramsWidget = ({ categories = [], programs = [] }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const onBtnClick = () => {
    app.sendGoogleAnalyticsEvent(FEED_GA.category, FEED_GA.events.programsInteracted, {
      widget: 'support programs',
    });
    dispatch(push(ROUTE_PATH[ROUTE_NAME.FINANCE]));
  };

  const displayedCategories = categories.slice(0, 5);
  const remainingCount = categories.length - displayedCategories.length;

  useEffect(() => {
    app.sendGoogleAnalyticsEvent(FEED_GA.category, FEED_GA.events.programsViewed, {
      widget: 'support programs',
    });
  }, []);

  return (
    <div className="programs-widget">
      <div className="widget-header">
        <div className="details">
          <div className="count">{programs.length}</div>
          <span className="divider">/</span>
          <div className="label">{t('programs_widget.label')}</div>
        </div>
      </div>
      <div className="widget-body">
        <h2 className="title">{t('programs_widget.title')}</h2>
        <h3 className="sub-title">
          {programs.length}
          {' '}
          {t('programs_widget.available_programs')}
        </h3>
        <ul className="options-list">
          {displayedCategories.map((option, key) => (
            <li className="options-item" key={key}>
              <div className="icon"><img src={option.icon} alt="icon" /></div>
              <div>{option.label}</div>
            </li>
          ))}
          {remainingCount > 0 && (
            <li className="remaining-count">
              {`+${remainingCount}`}
            </li>
          )}
        </ul>
      </div>
      <div className="widget-footer">
        <WidgetBtn title={t('programs_widget.actions.view_programs.button')} onClick={onBtnClick} />
        <AssistanceButton
          title={t('programs_widget.actions.assistance.button')}
          onClick={() => {
            app.cache.assistTrigBy = 'supportProgram';
          }}
        />
      </div>
    </div>
  );
};

ProgramsWidget.propTypes = {
  categories: PropTypes.array,
  programs: PropTypes.array,
};

export default ProgramsWidget;
